var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83386 0.0345542C9.93983 -0.0115181 10.0602 -0.0115181 10.1661 0.0345542L19.7495 4.20123C19.9016 4.26737 20 4.41746 20 4.58334V15.4167C20 15.5825 19.9017 15.7325 19.7497 15.7987L10.1826 19.9641L10.1744 19.9678C10.0669 20.0167 9.94382 20.0177 9.8356 19.9706L0.250386 15.7988C0.0983343 15.7326 0 15.5825 0 15.4167V4.58334C0 4.41746 0.0984016 4.26737 0.250531 4.20123L9.83386 0.0345542ZM0.833333 5.21885V15.1436L9.58333 18.9519V9.0232L0.833333 5.21885ZM1.46166 4.58334L9.99999 8.29567L18.5383 4.58334L10 0.871014L1.46166 4.58334ZM19.1667 5.21884L10.4167 9.0232V18.9533L19.1667 15.1437V5.21884Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.a8e81564b8664c5dc7e23ea217c033e1.svg";
export { ForwardRef as ReactComponent };